import { Component, Input, OnInit } from '@angular/core';
import { SLEntity } from '../entity';
import { SLDeletedMovement, SLMovement } from '../movement';
import { Router } from '@angular/router';

type ViewMode = 'default' | 'deleted' | 'draft';

@Component({
  selector: 'sl-entity-movements',
  templateUrl: './entity-movements.component.html',
})
export class SLEntityMovementsComponent implements OnInit {

  @Input()
  entity: SLEntity

  @Input()
  canAdd: boolean = false

  @Input()
  mode: ViewMode = 'default'

  movements: SLMovement[] | SLDeletedMovement []

  constructor(
    private router: Router,
  ) { }

  ngOnInit() {
    if (this.mode === 'default') {
      this.movements = this.entity.movements;
    }
    else if (this.mode === 'deleted') {
      this.movements = this.entity.deletedMovements;
    }
    else if (this.mode === 'draft')  {
      this.movements = this.entity.draftMovements;
    }
  }

  showMovement(movement: SLMovement) {
    if (this.mode === 'default') {
      this.router.navigate([this.router.url, 'movements', movement.id]);
    }
    else if (this.mode === 'deleted') {
      this.router.navigate([this.router.url, 'deleted-movements', movement.id]);
    }
    else if (this.mode === 'draft')  {
      this.router.navigate([this.router.url, 'draft-movements', movement.id]);
    }
  }
}
